import script from "./CommentItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./CommentItem.vue?vue&type=script&setup=true&lang=ts"

import "./CommentItem.vue?vue&type=style&index=0&id=6c8f0704&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c8f0704"]])

export default __exports__